var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Expand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-37.000000, -63.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Expand",
    transform: "translate(37.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02295213,10.7073801 L1.16162305,17.1165552 L6.87993781,17.1165552 L0.5,17.5 L0.5,11.1216279 L0.882010826,16.8456574 L7.02295213,10.7073801 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87922288,0.5 L1.15465599,0.882010826 L7.29277478,7.02309002 L0.882681886,1.16186074 L0.882681886,6.87993781 L0.5,0.5 L6.87922288,0.5 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0.5 L17.5,6.87922288 L17.1189105,1.1558572 L10.9768008,7.29299939 L16.8392,0.883604289 L11.1200622,0.883604289 L17.5,0.5 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7071845,10.9769099 L17.1165552,16.8382375 L17.1165552,11.1200622 L17.5,11.1200622 L17.5,17.5 L11.1216279,17.5 L11.1216279,17.1189105 L16.8455181,17.1189105 L10.7071845,10.9769099 Z",
    id: "Fill-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.1c70a82e6cbe50099e2cd6ed46a2e678.svg";
export { ForwardRef as ReactComponent };